import { render, staticRenderFns } from "./userAccess.vue?vue&type=template&id=fd3d89aa&scoped=true"
import script from "./userAccess.vue?vue&type=script&lang=js"
export * from "./userAccess.vue?vue&type=script&lang=js"
import style0 from "./userAccess.vue?vue&type=style&index=0&id=fd3d89aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3d89aa",
  null
  
)

export default component.exports